import React from 'react';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

interface ICircleLoaderProps {

}

const CircleLoader = (props: ICircleLoaderProps) => <SkeletonPlaceHolder className="circleButton"
                                                                         variant="circle" height={20}
                                                                         width={20}/>;
CircleLoader.defaultProps = {};
export default CircleLoader;
